export default __webpack_public_path__ + "static/media/Guru-Parampara-33.8ac67ba4.png";